import { useModal } from "context";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ColorPicker,
  CustomInput,
  FormButton,
  MessageBox,
} from "reusableComponents";
import styles from "./styles.module.scss";

const GroupFormModal = ({
  group: initialGroup,
  onSubmit,
  pickerOptions,
  confirmText,
  cancelText,
}) => {
  const { closeModal } = useModal();
  const { t } = useTranslation("global");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState(
    initialGroup || { label: "", color: "" }
  );

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!formData?.label || !formData?.color) return;

    setLoading(true);
    setError(null);

    try {
      await onSubmit(formData);
      closeModal();
    } catch (err) {
      setError(t("errors.genericError"));
    } finally {
      setLoading(false);
    }
  };

  const confirmButtonLabel =
    confirmText ||
    (formData?.id ? t("calendar.groups.edit") : t("buttons.validate"));
  const cancelButtonLabel = cancelText || t("buttons.cancel");

  return (
    <form
      onSubmit={handleSubmit}
      className={`${styles.modalForm} ${loading ? styles.loading : ""}`}
    >
      {!formData.id && (
        <MessageBox message={t("calendar.groups.addGroupText")} />
      )}
      <div className={styles.formField}>
        <CustomInput
          label={t("calendar.groups.name")}
          labelAbove
          name="label"
          value={formData.label || ""}
          handleChange={(e) => handleChange("label", e.target.value)}
          placeholder={t("calendar.groups.name")}
          error={
            formSubmitted && !formData.label ? t("validation.required") : null
          }
        />
      </div>

      <div className={styles.formField}>
        <ColorPicker
          value={formData.color || ""}
          onChange={(color) => handleChange("color", color)}
          options={pickerOptions}
        />
        {formSubmitted && !formData.color && (
          <MessageBox message={t("validation.required")} type="error" />
        )}
      </div>

      {error && <MessageBox message={error} type="error" />}

      <div className={styles.modalActions}>
        <FormButton
          label={cancelButtonLabel}
          onClick={() => {
            closeModal();
          }}
          variant="gray"
          disabled={loading}
        />
        <FormButton
          label={confirmButtonLabel}
          type="submit"
          variant="primary"
          disabled={loading}
          loading={loading}
        />
      </div>
    </form>
  );
};

export default GroupFormModal;
